import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={20}
            height={21}
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M18.333 9.78a.63.63 0 00.625-.624v-.834c0-3.675-1.117-4.791-4.792-4.791H8.958v1.875a.63.63 0 01-.625.625.63.63 0 01-.625-.625V3.53H5.833c-3.675 0-4.792 1.116-4.792 4.791v.417a.63.63 0 00.625.625c.8 0 1.458.658 1.458 1.458 0 .8-.658 1.459-1.458 1.459a.63.63 0 00-.625.625v.416c0 3.675 1.117 4.792 4.792 4.792h1.875V16.24a.63.63 0 01.625-.625.63.63 0 01.625.625v1.875h5.208c3.675 0 4.792-1.117 4.792-4.792a.63.63 0 00-.625-.625c-.8 0-1.459-.658-1.459-1.458 0-.8.659-1.458 1.459-1.458zm-9.375 2.85a.63.63 0 01-.625.626.63.63 0 01-.625-.625V9.014a.63.63 0 01.625-.625.63.63 0 01.625.625v3.617z"
            fill={theme["#0EA59D"]}
        />
        </svg>
    )
}

export default SvgComponent